import { Route } from '@angular/router'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FuseCardModule } from '@fuse/components/card'
import { FuseAlertModule } from '@fuse/components/alert'
import { SharedModule } from 'app/shared/shared.module'
import { DirectivesModule } from 'app/directives/directive.module'
import { PagaresComponent } from './pagares.component'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { CommonModule } from '@angular/common'
import { MatTableModule } from '@angular/material/table'
import { MatSelectModule } from '@angular/material/select'
import { MatDialogModule } from '@angular/material/dialog'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort'
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator'
import { MatPaginatorTranslator } from 'app/components/mat-custom-table/mat-paginator-translator'
import { FileUploadModule } from 'app/components/file-upload/file-upload.module'
import { PreviewPagareModule } from 'app/modules/pdf/preview-pagare/preview-pagare.module'
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseScrollbarModule } from '@fuse/directives/scrollbar';

export const routes: Route[] = [
	{
		path: '',
		component: PagaresComponent
	}
]

@NgModule({
	declarations: [PagaresComponent],
	imports: [
		RouterModule.forChild(routes),
		MatIconModule,
		CommonModule,
		MatInputModule,
		MatButtonModule,
		MatCheckboxModule,
		SharedModule,
		FuseCardModule,
		FuseAlertModule,
		DirectivesModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		MatTableModule,
		MatSelectModule,
		MatSortModule,
		MatPaginatorModule,
		FileUploadModule,
		PreviewPagareModule,
		MatTooltipModule,
		MatProgressBarModule,
		FuseScrollbarModule
	],
	providers: [
		/* Traducir al español el paginador */
		{
			provide: MatPaginatorIntl,
			useClass: MatPaginatorTranslator
		}
	]
})
export class PagaresModule { }
